const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Return a stable per-tab session id. First call in a tab creates one and
 * caches it in sessionStorage; subsequent calls in the same tab return the
 * same id. Different tabs get different ids by design.
 */
function getOrCreateSessionId() {
  try {
    let id = sessionStorage.getItem("fm_session_id");
    if (!id) {
      id =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem("fm_session_id", id);
    }
    return id;
  } catch (_) {
    return null;
  }
}

/**
 * Silent, fire-and-forget telemetry emit. Contract:
 *  - Never awaits.
 *  - Never throws.
 *  - Never produces a console.error toward the user.
 *  - Prefers `navigator.sendBeacon` (survives unload). Falls back to
 *    `fetch` with `keepalive:true`.
 *
 * Validation: `event_name` MUST match `^[a-z0-9_]{1,64}$`. Anything else
 * is silently dropped client-side (matches the backend contract).
 */
export function logEvent(event_name, metadata = null) {
  if (
    typeof event_name !== "string" ||
    !/^[a-z0-9_]{1,64}$/.test(event_name)
  ) {
    return;
  }
  try {
    const payload = {
      event_name,
      session_id: getOrCreateSessionId(),
      ref:
        typeof window !== "undefined"
          ? window.localStorage.getItem("fm_ref") || null
          : null,
      metadata: metadata && typeof metadata === "object" ? metadata : null,
    };
    const body = JSON.stringify(payload);
    const url = `${API}/api/analytics/log-event`;
    if (
      typeof navigator !== "undefined" &&
      typeof navigator.sendBeacon === "function"
    ) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(url, blob);
      return;
    }
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* silent — telemetry must never impact UX */
  }
}
